<template>
	<div class="photo-detail" v-if="end && !mipLinkLoading">
		<div class="top">
			<div class="detail-box-bg" v-if="imgurl!=''">
				<img v-setshow :src="imgurl" alt="" />
				<div class="bottom-bg">

				</div>
			</div>
			<div class="detail-box-panel" :class="{'have-img':imgurl!=''}">
				<div class="detail-box">
					<div class="detail-box-txt0">
						<div class="p1">{{ infos.title }}</div>
						<div class="p2">
							<span v-if="infos.majorName">{{ infos.majorName }}</span>
							<span v-if="infos.groupName">{{ infos.groupName }}</span>
						</div>
						<div class="p3">
							<div class="item1">
								<img src="../../assets/images/active/icon_adress.png" alt="" /> {{ infos.organization || "暂无报名服务单位" }}
							</div>
							<div class="item2">
								<img src="../../assets/images/active/icon_time.png" alt="" /> {{infos.time}}
							</div>
						</div>
						<div class="p4">
							<div class="idTab-time" v-if="infos.img && infos.img.length > 0">
								<div class="idTab" v-for="(ks, index) in infos.img" :key="index">
									<div class="overallBetween idTab-div">
										<div class="fileName">
											{{
							        ks.fileType == 1
							          ? "图片"
							          : ks.fileType == 2
							          ? "音频"
							          : ks.fileType == 3
							          ? "视频"
							          : ks.fileType == 4
							          ? "文档"
							          : ""
							      }}文件 | {{ ks.fileName }}
										</div>
										<a @click.stop="getcheck(ks)">查看></a>
										<!-- <a v-else-if="ks.fileType != 1" @click.stop="getcheck(ks)">查看></a> -->
									</div>
									<!-- 								<img v-setshow v-if="ks.fileType == 1" :src="ks.fileUrl" /> -->
								</div>
							</div>
						</div>

					</div>
				</div>
				<div class="detail-box">
					<div class="detail-box-title">
						<img src="../../assets/images/active/icon_label.png" alt="" /> 作品简介
					</div>
					<div class="detail-box-txt1">
						<div>{{ infos.slogan }}</div>
					</div>
				</div>
				<div class="detail-box">
					<div class="detail-box-title">
						<img src="../../assets/images/active/icon_rili.png" alt="" /> 参赛日程
					</div>
					<div class="detail-box-txt2">
						<div v-for="(item,index) in scheduleList" class="list">
							<div class="p1">
								<img src="../../assets/images/active/icon_chenggong.png" alt="" />
							</div>
							<div class="p2">
								{{item.content}}
							</div>
							<div class="p3">
								{{item.time}}
							</div>
						</div>
					</div>
				</div>
				<div class="detail-box">
					<div class="detail-box-title">
						<img src="../../assets/images/active/icon_baomingxinxi.png" alt="" /> 报名信息
					</div>
					<div class="detail-box-txt3">
						<div class="list">
							<div class="p2">
								作品编号
							</div>
							<div class="p3">
								{{infos.transactionId}}
							</div>
						</div>
						<div class="list">
							<div class="p2">
								作者姓名
							</div>
							<div class="p3">
								{{infos.author}}
							</div>
						</div>
					</div>
				</div>
			</div>



		</div>
		<!-- 	<div class="bottom">
			(操作功能暂时没有移动到详情页面)
		</div> -->

		<div class="page-wrap" v-if="end && !mipLinkLoading">
			<div class="reason" v-if="infos.grandPrize && infos.achievementType == 2">
				<div class="reason-tips"></div>
				<SignTitle title="推荐理由" :simplicity="true" />
				<div class="reason-content">
					{{ infos.recommendReason }}
				</div>
			</div>
		</div>
		<van-overlay :show="!end || mipLinkLoading">
			<van-loading size="24px" color="#fff">加载中...</van-loading>
		</van-overlay>

		<van-overlay :show="showShare" @click="showShare = false">
			<div class="share-box" v-if="end">
				<div class="infos-area">
					<img :src="infos.img" alt="" />
					<div>
						我参加了#第一届小精灵杯全国儿童书画大赛#，快来给我的作品点赞吧！
					</div>
				</div>
				<div class="share-area">
					<img src="../../assets/images/home/share-f-btn.png" alt="" />
					<img src="../../assets/images/home/share-fc-btn.png" alt="" />
					<img src="../../assets/images/home/share-link-btn.png" alt="" />
				</div>
				<div class="cancel-btn" @click="showShare = false">取消</div>
			</div>
		</van-overlay>
		<!-- 简介信息 -->
		<!-- <van-popup v-model="showSlogan" class="slogan" closeable close-icon="arrow-down" close-icon-position="top-right"
			position="bottom" :style="{ height: '50%' }">
			<div class="info-wrap">
				<div class="intro" v-html="content"></div>
			</div>
		</van-popup> -->
		<van-popup v-model="checkType" class="photo-tags" closeable position="bottom"
			:style="{ height: '100%', width: '100%' }" @close="beforeCloseHandler(checkData.fileType)">
			<div class="show-photo-tags">
				<img v-if="checkData.fileType == 1" :src="checkData.fileUrl" alt="" />
				<audio ref="audioPlayer" v-if="checkData.fileType == 2" width="100%" height="200" controls
					:src="checkData.fileUrl"></audio>
				<video ref="videoPlayer" v-if="checkData.fileType == 3" width="100%" height="200" controls
					:src="checkData.fileUrl"></video>
				<p style="text-align: center; margin-top: 20px">
					<a style="font-size: 18px; color: #16d77a" v-if="checkData.fileType == 4" :href="checkData.fileUrl">
						点击查看文档类作品
					</a>
				</p>
			</div>
		</van-popup>


		<van-dialog v-model="sendEmail" title="是否愿意体验《学与玩》电子刊" show-cancel-button show-confirm-button confirmButtonText="确定"
			cancelButtonText="我不需要" confirmButtonColor="#666" cancelButtonColor="#666" :before-close="holdBack"
			@confirm="sendEmailHandle" @cancel="sendEmailHandle(1)">
			<div class="tips-content">
				<p>{{ sendTips }}</p>
				<input class="email-inp" type="text" v-if="!hasEmail" v-model="inpEmail" />
			</div>
		</van-dialog>
	</div>
</template>

<script>
	// import Sign from "@/components/pub/Sign.vue";
	import SignTitle from "@/components/pub/SignTitle.vue";
	import {
		formatNumber,
		getfileTypeArr
	} from "@/utils/tool";
	import StepBar from "@/components/mine/StepBar";
	import {
		signature
	} from "@/utils/mixin/wx-js-sdk-signature";
	import {
		validate
	} from "@/utils/mixin/validate";
	import {
		getWorksDetails,
		getReleaseWorksDetails,
		likeWorks,
		checkLikeWorks
	} from "@/utils/api/user";
	import {
		sendReadingCode
	} from "@/utils/api/home";
	import {
		wxlogin
	} from "@/utils/mixin/wxlogin";
	// import imageUrl from '@/assets/images/imgurl.png';
	export default {
		mixins: [signature, wxlogin, validate],
		components: {
			// Sign,
			SignTitle,
			StepBar
		},
		computed: {
			canLikeHandel() {
				return (
					this.isVisitor &&
					this.role != 1 &&
					this.role != 2 &&
					this.role != 3 &&
					this.role != 0
				);
			}
		},
		data() {
			return {
				// 作品id
				id: null,
				// 当前角色
				role: -1,
				// 作品信息
				infos: null,
				// 加载完成
				end: false,
				// 评论轮播
				swipeList: [],
				// 作品日程
				scheduleList: [],
				// 日程第几步
				step: -1,
				// 查看作品详情
				show: false,
				// 作品详情图
				images: [],
				// 点赞按钮loading
				likeLoading: false,
				// 当前是否分享页面
				isShare: false,
				// 展示分享
				showShare: false,
				// 设置分享朋友/qq、分享朋友圈/qq空间的分享内容,
				// 有问题
				jsApiList: ["scanQRCode", "updateAppMessageShareData", "updateTimelineShareData"],
				// 展示标语
				showSlogan: false,
				// 是否登录
				isLogin: true,
				// 展示内容
				content: "",
				// 是否点赞
				isLike: false,
				// 跳转loading
				mipLinkLoading: false,
				// 是否游客
				isVisitor: true,
				hasEmail: false,
				sendEmail: false,
				sendTips: "",
				inpEmail: "",
				imgurl: '',

				checkType: false,
				checkData: {},
			};
		},
		methods: {
			getcheck(ks) {
				this.checkData = ks;
				this.checkType = true;
			},
			getFileType(fileName) {
				return fileName.slice(-(fileName.length - fileName.lastIndexOf(".") - 1));
			},
			// 获取作品信息
			getPageDetail() {
				const user = this.$store.state.userInfo;
				if (JSON.stringify(user) !== "{}") {
					// 用户已登录
					getWorksDetails(this.id).then((res) => {
						if (res.success) {
							const d = res.data;
							this.sendTips = `报名服务单位已为您的学生${d.babyName}成功报名，请填写您的邮箱，稍后系统将发送一个《学与玩》电子刊免费阅读码到您的邮箱。`;
							let img = getfileTypeArr(d.imgs)
							for (let i in img) {
								if (img[i].fileType == 1) {
									this.imgurl = img[i].fileUrl
								}
							}
							this.infos = {
								activityType: d.activityType,
								prize: d.prize,
								head: d.babyInfo ? JSON.parse(d.babyInfo).imgUrl : "",
								img: img,
								transactionId: d.transactionId,
								achievementType: d.achievementType,
								title: d.name,
								slogan: d.synopsis,
								author: d.babyName,
								grandPrize: d.grandPrize,
								groupName: d.groupName,
								majorName: d.majorName,
								organization: d.institutionName || "个人报名",
								time: d.addTime,
								activityName: d.activityName,
								province: d.province,
								email: d.email,
								likers: formatNumber(d.likeNum),
								recommendReason: d.recommendReason,
								lastLiker: d.userLikeWorksList
									.map((e) => {
										return e.userImg;
									})
									.slice(0, 5)
							};
							const role = this.$store.state.role;
							// if (!role) this.isSendEmail(d.sendEmailType, d.email, d.isSend);
							if (d.swCommentsWorksList) {
								this.swipeList = d.swCommentsWorksList.map((e) => {
									return {
										content: e.comment,
										score: e.fraction
									};
								});
							}
							this.setScheduleList(d);
							this.end = true;
							this.shareReady();
						}
					});
				} else {
					// 用户未登录
					getReleaseWorksDetails({
						id: this.id
					}).then((res) => {
						if (res.success) {
							const d = res.data;
							let img = getfileTypeArr(d.imgs)
							for (let i in img) {
								if (img[i].fileType == 1) {
									this.imgurl = img[i].fileUrl
								}
							}
							this.infos = {
								prize: d.prize,
								head: d.babyInfo ? JSON.parse(d.babyInfo).imgUrl : "",
								achievementType: d.achievementType,
								img: img,
								transactionId: d.transactionId,
								title: d.name,
								slogan: d.synopsis,
								author: d.babyName,
								grandPrize: d.grandPrize,
								groupName: d.groupName,
								majorName: d.majorName,
								organization: d.institutionName || "暂无报名服务单位",
								time: d.addTime,
								activityName: d.activityName,
								recommendReason: d.recommendReason,
								province: d.province,
								likers: formatNumber(d.likeNum),
								email: d.email,
								lastLiker: d.userLikeWorksList
									.map((e) => {
										return e.userImg;
									})
									.slice(0, 5)
							};
							if (d.swCommentsWorksList) {
								this.swipeList = d.swCommentsWorksList.map((e) => {
									return {
										content: e.comment,
										score: e.fraction
									};
								});
							}
							this.setScheduleList(d);
							this.end = true;
							this.shareReady();
						}
					});
				}
			},
			// 判断是否需要阅读码
			isSendEmail(sendEmailType, email, isSend) {
				if (sendEmailType === 0 && isSend === 1) {
					// 弹出
					if (email) {
						// 有邮箱
						this.hasEmail = true;
					} else {
						// 无邮箱
						this.hasEmail = false;
					}
					this.sendEmail = true;
				}
			},
			holdBack(a, b) {
				return b(this.close);
			},
			// 提交信息 0 我不需要 ； 1确定发送
			sendEmailHandle(type = 0) {
				if (type) {
					//
					sendReadingCode({
						id: this.id,
						sendEmailType: 2
					});
					this.sendEmail = false;
				} else {
					//
					if (!this.inpEmail && !this.infos.email) {
						this.$toast.fail("请输入邮箱");
						this.close = false;
						return;
					}
					const pass = this.validate.mail("inpEmail");
					if (!pass) {
						this.$toast.fail("邮箱格式不正确");
						this.close = false;
						return;
					}
					// 发送阅读码
					else
						sendReadingCode({
							id: this.id,
							email: this.infos.email || this.inpEmail,
							sendEmailType: 1
						}).then((res) => {
							if (res.success) {
								this.$root.$toast.success("阅读码已发送，请注意查收。");
								this.sendEmail = false;
								this.close = true;
							}
						});
				}
			},
			// 查看作品图片
			viewImage(img) {
				// eslint-disable-next-line
				// this.$root.$ImagePreview([img]);
				this.show = true;
				this.images = [img];
			},
			//
			// downloadWorks() {
			//   // 非微信下载
			//   let url = this.images[0];
			//   let a = document.createElement("a");
			//   a.setAttribute("download", url);
			//   a.href = url;
			//   a.click();
			// },
			// 梳理参赛日程  (后端太懒他不想做)
			setScheduleList({
				addTime,
				swCommentsWorksList,
				stageType,
				worksType,
				channelSumitTime,
				achievementType,
				finalReleaseTime,
				prize,
				prizeName,
			}) {
				this.scheduleList = [];
				this.scheduleList.push({
					content: "提交成功",
					time: addTime
				});
				this.step++;
				this.scheduleList.push({
					content: "进入待评区",
					time: addTime
				});
				this.step++;
				if (swCommentsWorksList && swCommentsWorksList.length && swCommentsWorksList.length > 0) {
					this.scheduleList.push({
						content: `已被评委评审`,
						time: swCommentsWorksList[swCommentsWorksList.length - 1].addTime || "-"
					});
					this.step++;

					// swCommentsWorksList.forEach((e, i) => {
					//   this.scheduleList.push({
					//     content: `已被${i + 1}位评委点评`,
					//     time: e.addTime || "-"
					//   });
					//   this.step++;
					// });
					// const len = swCommentsWorksList.length;
					// this.scheduleList.push({
					//   content: `已被${len}位评委点评`,
					//   time: swCommentsWorksList[len - 1].addTime || "-"
					// });
					// this.step++;
				}
				// else {
				//  if(recommendReason){
				//   this.scheduleList.push({
				//     content: `已被1位评委点评`,
				//     time: recommendTime || "-"
				//   });
				//   this.step++;
				//  }
				//      return;
				//    }
				if (stageType == 1) {
					this.scheduleList.push({
						content: "等待评选结果",
						time: channelSumitTime
					});
					this.step++;
				}
				// alert(1)
				if (achievementType == 2) {
					this.scheduleList.push({
						content: `${prizeName}`,
						time: finalReleaseTime
					});
					// if (institutionType == 0) {
					//   this.scheduleList.push({
					//     content: `${
					//       prize == 1
					//         ? "获得一等奖"
					//         : prize == 2
					//         ? "获得二等奖"
					//         : prize == 3
					//         ? "获得三等奖"
					//         : prize == 4
					//         ? "获得优秀奖"
					//         : "未获奖，谢谢参与"
					//     }`,
					//     time: finalReleaseTime
					//   });
					// } else {
					//   this.scheduleList.push({
					//     content: `${
					//       prize == 1
					//         ? "获得一等奖"
					//         : prize == 2
					//         ? "获得二等奖"
					//         : prize == 3
					//         ? "获得三等奖"
					//         : prize == 4
					//         ? "未获奖，谢谢参与"
					//         : "未获奖，谢谢参与"
					//     }`,
					//     time: finalReleaseTime
					//   });
					// }
					this.step++;
				}else if(worksType == 3){
					  this.scheduleList.push({
					    content: `谢谢参与`,
					    time: finalReleaseTime
					  });
						this.step++;
				}
				// if (achievementType == 2 && prize == 1 && activityType !== 1) {
				//   this.scheduleList.push({
				//     content: "进入决赛",
				//     time: finalReleaseTime
				//   });
				//   this.step++;
				// }
			},
			// 分享
			pullWxShare() {
				this.showShare = true;
			},
			// 分享设置
			shareReady() {
				/* eslint-disable */
				wx.ready(() => {
					const infos = this.infos;
					let imgurl = this.imgurl;
					let queryStr = `?id=${this.$route.query.id}`;
					const href = window.location.href;
					// const href = window.location.origin + this.$route.path + queryStr;
					const active = infos.activityName;
					wx.updateAppMessageShareData({
						title: infos.title, // 分享标题
						desc: `我参加了#${active}#，快来给我的作品点赞吧！`, // 分享描述
						link: href, // window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
						imgUrl: imgurl, // 分享图标
						success: () => {
							// 设置成功
							// this.$root.$toast.success("设置成功！");
						},
						fail: (err) => {
							const followed = err.errMsg.indexOf(
								"the permission value is offline verifying"
							);
							if (followed > 0) {
								if (!this.mipLinkLoading) {
									this.$notify({
										type: "danger",
										message: "请检查是否关注该公众号"
									});
								}
								this.$root.$toast.fail("获取页面权限失败，请刷新页面后重试！");
							} else {
								this.$root.$toast.fail(JSON.stringify(err));
							}
						}
					});
					wx.updateTimelineShareData({
						title: infos.title, // 分享标题
						desc: `我参加了#${active}#，快来给我的作品点赞吧！`, // 分享描述
						link: href, //window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
						imgUrl: imgurl, // 分享图标
						success: () => {
							// 设置成功
							// this.$root.$toast.success("设置成功！");
						},
						fail: (err) => {
							const followed = err.errMsg.indexOf(
								"the permission value is offline verifying"
							);
							if (followed > 0) {
								if (!this.mipLinkLoading) {
									this.$notify({
										type: "danger",
										message: "请检查是否关注该公众号"
									});
								}
								this.$root.$toast.fail({
									message: "获取页面权限失败，请刷新页面后重试！",
									duration: 2000,
									onClose: () => {
										this.refreshJSToken();
									}
								});
							} else {
								this.$root.$toast.fail({
									message: JSON.stringify(err),
									duration: 2000,
									onClose: () => {
										this.refreshJSToken();
									}
								});
							}
						}
					});
				});
				/* eslint-disable */
			},
			// wxlogin callback 微信登录回调
			wxLoginCallback() {
				const {
					id
				} = this.$route.query;
				let params = {};
				if (id) params.id = id;
				// 刷新页面js权限
				this.$root.mipLink("/player/photodetail", params);
			},
			// 点赞
			likeHandle() {
				if (this.isLike) {
					return;
				}
				// 检测用户信息
				const wxinfo = this.$store.state.wxUserInfo;
				if (!wxinfo) {
					this.toAuthorizationPage("wxLoginCallback");
				} else {
					this.likeLoading = true;
					const p = {
						openId: wxinfo.openid,
						userImg: wxinfo.headimgurl,
						userName: wxinfo.nickname,
						worksId: this.id
					};
					likeWorks(p).then((res) => {
						if (res.success) {
							this.$root.$toast.success("点赞成功！");
							this.checkLike();
							this.getPageDetail();
						}
						this.likeLoading = false;
					});
				}
			},
			// 检测用户是否点赞
			checkLike() {
				const openid = this.$store.state.openid;
				if (!openid) {
					return;
				}
				checkLikeWorks({
					worksId: this.id,
					openId: openid
				}).then((res) => {
					if (res.success) {
						this.isLike = res.data.isLikeWorks;
						this.isVisitor = !res.data.isBindTel;
					}
				});
			}
		},
		mounted() {
			this.id = this.$route.query.id;
			// this.isShare = this.$route.query.isshare ? true : false;
			this.role = this.$store.state.role;
			const code = this.$route.query.code;
			if (code) {
				this.mipLinkLoading = true;
			}
			const userInfo = this.$store.state.userInfo;
			this.isLogin = JSON.stringify(userInfo) !== "{}";
			if (this.isLogin) this.isVisitor = false;
			this.getPageDetail();
			this.checkLike();
		}
	};
</script>
<style lang="scss" scoped>
	// ::deep html{
	// 	background: #F8F8F9;
	// }
	.detail-box-bg {
		position: relative;

		img {
			width: 100% !important;
			height: 238px !important;
			object-fit: cover;
		}

		.bottom-bg {
			position: absolute;
			bottom: 0;
			left: 0;
			right: 0;
			height: 64px;
			background: linear-gradient(180deg, rgba(248, 248, 249, 0) 0%, #F8F8F9 100%);
		}
	}

	.detail-box-panel {
		padding: 0 15px;
		padding-top: 15px;

		&.have-img {
			position: relative;
			margin-top: -50px;
			padding-top: 0;
		}
	}

	.detail-box {
		background: #FFFFFF;
		border-radius: 8px 8px 8px 8px;
		padding: 15px;
		margin-bottom: 15px;

		.detail-box-title {
			font-weight: bold;
			font-size: 17px;
			color: #222222;
			display: flex;
			align-items: center;

			img {
				width: 20px;
				margin-right: 5px;
			}
		}

		.detail-box-txt0 {
			.p1 {
				font-weight: bold;
				font-size: 23px;
				color: #333333;
				line-height: 27px;
			}

			.p2 {
				padding-top: 8px;

				span {
					background: rgba(255, 114, 70, 0.1);
					border-radius: 25px 25px 25px 25px;
					font-size: 12px;
					color: #FF7246;
					padding: 4px 10px;
					margin-right: 10px;
					font-weight: 400;
				}
			}

			.p3 {
				display: flex;
				align-items: center;
				font-weight: 400;
				font-size: 12px;
				color: #666666;
				padding-top: 15px;

				.item1 {
					flex: 1;
				}

				.item2 {
					width: 60%;

					img {
						width: 18px;
						height: 18px;
					}
				}

				.item1,
				.item2 {
					display: flex;
					// flex: 1;
					align-items: center;
				}

				img {
					width: 14px;
					height: 14px;
					margin-right: 2px;

				}
			}

			.p4 {
				padding-top: 15px;

				.idTab {
					display: flex;
					align-items: center;
					width: 315px;
					min-height: 35px;
					background: #f8f8f9;
					border-radius: 8px 8px 8px 8px;
					padding: 2px 10px;
					margin-bottom: 10px;
					font-size: 12px;
					font-family: PingFang SC, PingFang SC;
					font-weight: 400;
					color: #666666;

					&:last-child {
						margin-bottom: 0;
					}

					.fileName {
						width: 250px;
						white-space: nowrap;
						overflow: hidden;
						text-overflow: ellipsis;
					}

					.idTab-div {
						width: 100%;
					}

					a {
						font-size: 12px;
						font-family: PingFang SC, PingFang SC;
						font-weight: 400;
						color: #999999;
					}

					img {
						object-fit: contain;
						max-height: 210px;
						width: 100% !important;
						border-radius: 8px;
					}
				}
			}
		}

		.detail-box-txt1 {
			padding-top: 10px;
			font-weight: 400;
			font-size: 14px;
			color: #222222;
			line-height: 21px;
		}

		.detail-box-txt2 {
			margin-bottom: -10px;
			margin-top: 10px;

			.list {
				border-bottom: 1px solid #EEEEEE;
				display: flex;
				align-items: center;
				padding: 10px 0;

				&:last-child {
					border: none;
				}

				.p1 {
					margin-right: 5px;

					img {
						width: 19px;
						height: 19px;
					}
				}

				.p2 {
					font-weight: 400;
					font-size: 14px;
					color: #222222;
					line-height: 16px;
					flex: 1;
				}

				.p3 {
					font-size: 12px;
					color: #999999;
				}
			}
		}

		.detail-box-txt3 {
			margin-bottom: -5px;
			margin-top: 10px;

			.list {

				display: flex;
				align-items: center;
				padding: 7px 0;

				.p2 {
					font-weight: 400;
					font-size: 14px;
					color: #666666;
					flex: 1;
				}

				.p3 {
					font-size: 14px;
					color: #222222;
				}
			}
		}

		// margin: 15px;
	}

	.photo-detail {
		// padding-bottom: 20px;
		height: 100vh;
		background: #F8F8F9;

		display: flex;
		flex-direction: column;

		.top {
			flex: 1;
			overflow-y: auto;
		}

		// .bottom{
		// 	height: 50px;
		// 	background-color: #fff;
		// }
		// padding: 15px;

		.page-wrap {
			.like-handle {
				display: flex;
				flex-direction: column;
				align-items: center;

				.author-infos-area {
					display: flex;
					flex-direction: column;
					align-items: center;

					img {
						width: 72px;
						height: 72px;
						border-radius: 36px;
					}

					div {
						line-height: 28px;
						font-size: 20px;
						color: #444;
						margin-top: 12px;
					}

					p {
						font-size: 16px;
						color: #999;
						line-height: 22px;
						margin-top: 8px;
					}

					span {
						display: flex;
						margin-top: 16px;

						img {
							margin-right: 8px;
							height: 22px;
							width: 16px;
						}

						font-size: 16px;
						line-height: 22px;
					}
				}

				.link-btn {
					margin-top: 30px;
					width: 141px;
					height: 37px;
					background: #ffffff;
					box-shadow: 0px 3px 6px rgba(5, 75, 27, 0.2);
					border-radius: 19px;
					display: flex;
					justify-content: center;
					align-items: center;
					font-size: 16px;
					color: #333;

					&.ed {
						background: #eee;
					}
				}
			}
		}

		.works-dowanload {
			position: fixed;
			height: 52px;
			width: 52px;
			left: 161.5px;
			bottom: 80px;

			img {
				width: 100%;
				height: 100%;
			}
		}

		// background-color: #f2f2f2;
		width: 100%;
		max-width: 10rem;
		text-align: left;

		.infos {
			min-height: 190px;
			background-color: #fff;
			margin: 50px 20px;
			margin-bottom: 22px;
			width: 335px;
			display: flex;
			box-shadow: 0px 2px 5px rgba(5, 75, 27, 0.2);
			border-radius: 8px;
			max-height: 190px;

			.thumbnail {
				position: relative;
				width: 135px;
				height: 190px;
				overflow: hidden;
				border-radius: 15px;
				margin-top: -15px;
				background: #000;
				margin-left: -10px;
				display: flex;
				align-items: center;
				justify-content: center;

				img {
					height: 120%;
					position: absolute;
				}

				.act-name {
					height: 30px;
					line-height: 15px;
					color: #fff;
					font-size: 12px;
					position: absolute;
					bottom: 0;
					width: 100%;
					padding: 10px;
				}
			}

			.photo-info {
				flex: 1;
				max-width: 210px;
				margin-left: 10px;
				display: flex;
				flex-direction: column;
				position: relative;

				.title {
					width: 100%;
					margin-top: 12px;

					.tit {
						font-size: 18px;
						font-weight: 900;
						color: #666;
						line-height: 24px;
						width: 190px;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;

						img {
							width: 14px;
							height: 14px;
							margin-right: 18px;
						}
					}

					.slogan {
						width: 100%;
						position: relative;

						div {
							font-size: 12px;
							margin: 5px 0;
							color: #999;
							line-height: 20px;
							max-width: 80%;
							overflow: hidden;
							text-overflow: ellipsis;
							white-space: nowrap;
						}

						// display: -webkit-box;
						// -webkit-line-clamp: 2;
						// -webkit-box-orient: vertical;
						// display: -moz-box;
						// -moz-line-clamp: 2;
						// -moz-box-orient: vertical;
						// word-wrap: break-word;
						// word-break: break-all;
						// white-space: normal;
						&::before {
							content: "";
							position: absolute;
							z-index: 1;
							height: 100%;
							width: 10px;
							display: block;
							background: url("../../assets/images/active/icon-right-arr.png");
							background-size: 10px 10px;
							background-position: center center;
							background-repeat: no-repeat;
							top: 0;
							right: 15px;
						}
					}

					// border-bottom: 1px solid #f2f2f2;
				}

				.author {
					flex: 1;
					max-height: 94px;
					line-height: 24px;
					font-size: 12px;
					color: #999999;
					display: flex;
					flex-direction: column;
					justify-content: space-between;

					.ator-info {
						display: flex;
						flex-wrap: wrap;
						max-height: 53px;
						overflow: hidden;

						span {
							padding: 0 5px;
							background-color: #f2f2f2;
							color: #000;
							font-size: 12px;
							display: block;
							margin-right: 8px;
							overflow: hidden;
							text-overflow: ellipsis;
							white-space: nowrap;
							border-radius: 5px;
							max-height: 24px;

							&:nth-child(1) {
								margin-bottom: 5px;
							}

							&:nth-child(2) {
								margin-bottom: 5px;
							}
						}
					}

					.org {
						max-width: 180px;

						p {
							max-width: 180px;
							overflow: hidden;
							text-overflow: ellipsis;
							white-space: nowrap;
							line-height: 20px;
						}
					}

					.time {}
				}

				.browse-infos {
					display: flex;
					justify-content: space-between;
					align-items: center;
					bottom: 0;
					width: 100%;
					padding-right: 10px;

					.likers {
						display: flex;
						align-items: center;
						line-height: 20px;

						img {
							width: 10px;
							height: 11px;
						}

						span {
							font-size: 14px;
							color: #666666;
							margin-left: 10px;
						}
					}

					.last-liker {
						width: 120px;
						display: flex;
						flex-direction: row-reverse;
						align-items: center;

						.heads {
							display: flex;
							align-items: center;

							img {
								width: 16px;
								height: 16px;
								border-radius: 8px;
							}
						}

						span {
							margin-left: 5px;
							font-size: 12px;
							color: #c8c8c8;
						}
					}

					.share {
						font-size: 12px;
						width: 64px;
						height: 30px;
						border-radius: 32px;
						display: flex;
						align-items: center;
						justify-content: center;
						color: #fff;
						background-image: linear-gradient(-90deg,
								rgba(55, 220, 141, 1) -15%,
								rgba(30, 191, 95, 1) 100%);
					}
				}
			}
		}

		.reason {
			padding: 10px 20px;
			padding-top: 0;
			max-width: 10rem;
			width: 100%;
			background-color: #fff;

			.reason-tips {
				width: 214px;
				height: 210px;
				background-image: url("../../assets/images/home/grand-prize-ico.png");
				background-size: 100% 100%;
				background-position: center center;
				background-repeat: no-repeat;
				color: #fff;
				display: flex;
				align-items: center;
				justify-content: center;
				font-size: 12px;
				margin: 0 auto;
			}

			.reason-content {
				position: relative;
				// &::before {
				//   content: "推荐理由";
				//   height: 26px;
				//   border-radius: 5px;
				//   color: #fff;
				//   font-size: 12px;
				//   line-height: 0px;
				//   width: 62px;
				//   position: absolute;
				//   top: 0;
				//   left: 0;
				//   background-color: #16d77a;
				//   text-align: right;
				//   display: flex;
				//   align-items: center;
				//   justify-content: center;
				//   text-indent: 0;
				// }
				margin-top: 12px;
				// text-indent: 66px;
				font-size: 12px;
				padding: 8px 12px;
				line-height: 26px;
				color: #666;
				background-color: #f2f2f2;
				border-radius: 8px;
			}
		}

		.remark {
			margin-top: 10px;
			padding: 10px 0px;
			max-width: 10rem;
			width: 100%;
			background-color: #fff;

			.remark-title {
				padding: 0px 20px;
			}

			.remark-swipe {
				height: 170px;
				width: 375px;

				.my-swipe {
					height: 100%;
					width: 100%;
				}

				.remark-item {
					height: 130px;
					background-color: #f9f9f9;
					border-radius: 10px;
					padding: 8px 12px;
					width: 335px;
					margin: 0 20px;
					overflow: hidden;
					position: relative;
					display: flex;

					.score {
						padding: 15px;
						display: flex;
						flex-direction: column;
						align-items: center;
						justify-content: center;

						p {
							color: #16d77a;
							// font-size: 16px;
							// margin: 0 5px;
							font-size: 53px;
							color: #ff635a;
							position: relative;

							&:after {
								content: "分";
								position: absolute;
								bottom: 10px;
								color: #999999;
								right: -15px;
								font-size: 14px;
							}
						}

						div {
							line-height: 20px;
							color: #999999;
							margin-top: 4px;
							font-size: 14px;
						}

						span {
							display: block;
							height: 1px;
							width: 36px;
							background-color: #16d77a;
						}
					}

					.remark-content {
						width: 220px;
						font-size: 12px;
						line-height: 22px;
						color: #666666;
						overflow: hidden;
						text-overflow: ellipsis;
						display: -webkit-box;
						-webkit-line-clamp: 5;
						-webkit-box-orient: vertical;
						display: -moz-box;
						-moz-line-clamp: 5;
						-moz-box-orient: vertical;
						word-wrap: break-word;
						word-break: break-all;
						white-space: normal;
					}
				}
			}
		}

		.schedule {
			margin-top: 10px;
			padding: 10px 20px;
			max-width: 10rem;
			width: 100%;
			background-color: #fff;

			.schdl-item {
				min-width: 140px;

				div {}

				p {}
			}
		}

		.photo-view {
			padding: 0px 20px;
			max-width: 10rem;
			width: 100%;
			background-color: #fff;
			margin-bottom: 30px;

			div {
				img {
					width: 100%;
				}
			}
		}

		.van-overlay {
			z-index: 10;
			display: flex;
			justify-content: center;
			align-items: center;

			.share-box {
				position: absolute;
				height: 273px;
				width: 351px;
				background: #fff;
				background: #fff;
				border-radius: 16px;
				padding: 15px 0;
				bottom: 74px;
				left: 12px;
				overflow: hidden;
				display: flex;
				flex-direction: column;

				.infos-area {
					padding: 0 15px;
					height: 118px;
					display: flex;

					img {
						width: 122px;
						height: 102px;
						border-radius: 8px;
					}

					div {
						width: 158px;
						font-size: 16px;
						margin-left: 20px;
						color: #333;
						line-height: 22px;
						text-align: justify;
						text-align-last: left;
					}
				}

				.share-area {
					display: flex;
					flex: 1;
					justify-content: space-between;
					padding: 0 25px;
					align-items: center;

					img {
						height: 82px;
						width: 82px;
					}
				}

				.cancel-btn {
					height: 40px;
					text-align: center;
					line-height: 52px;
					font-size: 16px;
					color: #999;
					border-top: 1px solid #999;
				}
			}
		}

		.tips-content {
			width: 80%;
			margin: 0 auto;
			font-size: 14px;
			color: #999;
			margin-bottom: 10px;

			p {
				margin: 10px 0;
			}

			input {
				border: 1px solid #aaa;
				width: 100%;
			}
		}
	}

	.van-popup.photo-tags {
		background-color: unset;

		.checkClass {
			width: 8.1067rem;
			border-radius: 0.4267rem;
			overflow: hidden;
			margin-top: 5vh;
			display: flex;
		}

		.show-photo-tags {
			height: 100%;
			width: 100%;
			display: flex;
			justify-content: center;
			align-items: center;
			flex-direction: column;
			overflow: hidden;

			p {
				font-size: 14px;
				text-align: center;
				color: #f2f2f2;
			}

			img {
				width: 275px;
				border-radius: 16px;
				overflow: hidden;
				margin-top: 2vh;
				display: flex;
			}
		}
	}
</style>
<style lang="scss">
	.photo-detail {
		.van-popup.slogan {
			border-radius: 20px 20px 0 0;
			overflow-y: hidden;

			.van-icon {
				right: calc((100% - 16px) / 2);
				font-size: 16px;

				&::after {
					content: "";
					position: absolute;
					left: -3px;
					top: -3px;
					height: 20px;
					width: 20px;
					box-sizing: content-box;
					border: 1px solid #c8c9cc;
					border-radius: 50%;
				}
			}
		}

		.info-wrap {
			margin-top: 50px;
			padding: 0 20px;
			height: 100%;
			overflow-y: scroll;

			.intro {
				margin-top: 20px;
				line-height: 24px;
				font-size: 14px;
				color: #999;
				padding-bottom: 80px;
			}
		}
	}
</style>